import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { ApexOptions } from "apexcharts";
import axios from "axios";

interface IResposta {
  semana: string;
  taxa_adesao: number;
}

const TaxaAdesaoChart = () => {
 const [data, setData] = useState<IResposta[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get("/autoavaliacao-resposta/dashboard");
      const cap: IResposta[] = (data as IResposta[]).map(d => {
          return d.taxa_adesao > 100 ? {...d, taxa_adesao: 100} : d
      })
      setData(cap);
    };

    fetchData();
  }, []);

  const labels = useMemo(
    () => data?.map((item) => item.semana) ?? [],
    [data]
  );

  const series = useMemo(
    () => [
      {
        name: "Taxa de adesão",
        type: "line" as const,
        data: data?.map((item) => item.taxa_adesao) ?? [],
      },
    ],
    [data]
  );

  const media = useMemo(() => {
    const valores = series[0].data;

    if (!valores.length) return "0";

    return (
      valores.reduce((soma, valor) => soma + Number(valor), 0) /
      valores.length
    ).toFixed(2);
  }, [series]);

  const apexOpts: ApexOptions = {
    chart: {
      height: 378,
      type: "line",
      offsetY: 10,
    },
    stroke: {
      width: [2, 3],
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    colors: ["rgba(79,198,225,0.85)", "#4a81d4"],
    dataLabels: {
      enabled: true,
      formatter: (val) => `${Math.round(Number(val))}%`,
    },
    labels,
    xaxis: {
      categories: labels,
      labels: {
        rotateAlways: true,
      },
    },
    legend: {
      offsetY: 7,
    },
    grid: {
      padding: {
        bottom: 20,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.25,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.75,
        opacityTo: 0.75,
        stops: [0, 0, 0],
      },
    },
    yaxis: [
      {
        title: {
          text: "Taxa de adesão",
        },
        min: 0,
        max: 100,
        labels: {
          formatter: (val) => `${Math.round(val)}%`,
        },
      },
    ],
  };

  return (
    <Card>
      <Card.Body>
        <h4 className="header-title mb-3">
          Taxa de adesão à autoavaliação
        </h4>

        <div dir="ltr">
          <Chart
            options={apexOpts}
            series={series}
            type="line"
            height={380}
            className="apex-charts mt-4"
          />

          <div
            style={{
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: 14,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              Média de adesão da empresa
            </p>

            <p
              style={{
                color: "#4fc6e1d8",
                fontSize: 18,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              {media}%
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TaxaAdesaoChart;